import React, { Component, useState, useEffect, } from "react";
import SyncLoader from "react-spinners/SyncLoader";
import BoxDesc from "./boxComp/boxDesc";
import BoxOffer from "./boxComp/boxOffer";
import Announcement from "./boxComp/announcement";
import Tiers from "./HomeComp/tiers";
import ObjectInBox from "./boxComp/objectInBox";

function Box() {

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true)
        setTimeout(() => {
            setLoading(false)
        }, 1500)
    }, [])

    return (

        <React.Fragment>

            {loading ?

                <div className="animation_widget">
                    <SyncLoader
                        loading={loading}
                        size={30}
                        color={"yellow"}
                    />
                </div>

                :

                <React.Fragment>
                    <BoxDesc />
                    <BoxOffer />
                    <Announcement />
                    <Tiers />
                    <ObjectInBox />
                </React.Fragment>

            }

        </ React.Fragment>

    );


}

export default Box;